import axios from "axios";
import getIdeasApiURL from "@src/services/ideas/getIdeasApiURL";

async function getFollowingChannels() {
  try {
    const path = `/api/ideas/channels/following`;
    const r = await axios.get(`${getIdeasApiURL()}${path}`);

    return r;
  } catch (e) {
    return e;
  }
}

export default getFollowingChannels;
